import React from "react";
import "./WebIntegratedLessonPlan.css";
import WebAudioPlayer from "../WebAudioPlayer";

import bigQstnIcon from "../../../../appAssets/bigQstnIcon.png";
import predQstnIcon from "../../../../appAssets/predQstnIcon.png";
import refQstnIcon from "../../../../appAssets/refQstnIcon.png";
import funCloseIcon from "../../../../appAssets/funCloseIcon.svg";

export interface LessonPlanQuestion {
  name: string;
  question: string;
  url: string;
}

interface Props {
  lessonPlanQuestion: LessonPlanQuestion;
  onStart: () => void;
}

const QUESTION_META: Record<
  string,
  { header: string; sub_header: string; headerIcon: string; btnTitle: string }
> = {
  BigQuestion: {
    header: "Before we start...",
    sub_header: "Let us discuss together.",
    headerIcon: bigQstnIcon,
    btnTitle: "Start the story →",
  },
  PredictionQuestion: {
    header: "Make a prediction!",
    sub_header: "Let us predict what will happen next.",
    headerIcon: predQstnIcon,
    btnTitle: "Done!",
  },
  ReflectionQuestion: {
    header: "Let's reflect!",
    sub_header: "Let us reflect together.",
    headerIcon: refQstnIcon,
    btnTitle: "Continue",
  },
};

const WebIntegratedLessonPlan: React.FC<Props> = ({
  lessonPlanQuestion,
  onStart,
}) => {
  const meta =
    QUESTION_META[lessonPlanQuestion?.name] ?? QUESTION_META.BigQuestion;

  return (
    <div className="web-ilp-overlay">
      <div className="web-ilp-card">
        <button className="web-ilp-close-btn" onClick={onStart}>
          <img src={funCloseIcon} alt="close" />
        </button>

        <div className="web-ilp-header">
          <img
            src={meta.headerIcon}
            alt={meta.header}
            className="web-ilp-icon"
          />
          <p className="web-ilp-title">{meta.header}</p>
          <p className="web-ilp-subtitle">{meta.sub_header}</p>
        </div>

        <div className="web-ilp-question-section">
          <p className="web-ilp-question">{lessonPlanQuestion?.question}</p>
        </div>

        <div className="web-ilp-button-section">
          <button className="web-ilp-btn" onClick={onStart}>
            {meta.btnTitle}
          </button>
        </div>
      </div>

      {!!lessonPlanQuestion?.url && (
        <WebAudioPlayer uri={lessonPlanQuestion.url} />
      )}
    </div>
  );
};

export default WebIntegratedLessonPlan;
